import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Policies from './pages/Policies';
import PolicyDetail from './pages/PolicyDetail';
import Slabs from './pages/Slabs';
import Employees from './pages/Employees';
import EmployeeDetail from './pages/EmployeeDetail';
import Claims from './pages/Claims';
import Endorsements from './pages/Endorsements';
import TermCoverages from './pages/TermCoverages';
import TermClaims from './pages/TermClaims';
import EmployeeFamilyRequest from './pages/EmployeeFamilyRequest';
import EmployeeFamilyRemove from './pages/EmployeeFamilyRemove';
import EmployeeFamilyRequestDetail from './pages/EmployeeFamilyRequestDetail';
import EmployeeHospitals from './pages/EmployeeHospitals';
import EmployeeProfile from './pages/EmployeeProfile';
import ProfileCorrections from './pages/ProfileCorrections';
import EmployeePortalUsers from './pages/EmployeePortalUsers';
import Approvals from './pages/Approvals';
import HospitalManagement from './pages/HospitalManagement';
import Reports from './pages/Reports';
import Notifications from './pages/Notifications';
import AuditLog from './pages/AuditLog';
import HrmsSync from './pages/HrmsSync';
import { useAuth } from './context/AuthContext';

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="my-family" element={<EmployeeFamilyRequest />} />
        <Route path="my-family/remove/:memberId" element={<EmployeeFamilyRemove />} />
        <Route path="my-family/requests/:id" element={<EmployeeFamilyRequestDetail />} />
        <Route path="hospital-management" element={<HospitalManagement />} />
        <Route path="hospitals" element={<EmployeeHospitals />} />
        <Route path="my-profile" element={<EmployeeProfile />} />
        <Route path="profile-corrections" element={<ProfileCorrections />} />
        <Route path="policies" element={<Policies />} />
        <Route path="policies/:id" element={<PolicyDetail />} />
        <Route path="slabs" element={<Slabs />} />
        <Route path="employees" element={<Employees />} />
        <Route path="employees/:id" element={<EmployeeDetail />} />
        <Route path="employee-portal-users" element={<EmployeePortalUsers />} />
        <Route path="approvals" element={<Approvals />} />
        <Route path="term-coverages" element={<TermCoverages />} />
        <Route path="claims" element={<Claims />} />
        <Route path="term-claims" element={<TermClaims />} />
        <Route path="endorsements" element={<Endorsements />} />
        <Route path="reports" element={<Reports />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="hrms-sync" element={<HrmsSync />} />
        <Route path="audit" element={<AuditLog />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
